export default __webpack_public_path__ + "static/media/gold_transparency.8c798c28.png";